<template>
    <div class="Columns-page">
        <div class="sub-container">
<!--            <div class="breadcrumbs">-->
<!--                <ul>-->
<!--                    <li><a :href="$store.state.hrefPrefix + '/'">{{ $t('home') }}</a></li>-->
<!--                    <li><img src="/assets/images/pagination-right.svg" alt=""/></li>-->
<!--                    <li>{{ $t('columns') }} </li>-->
<!--                </ul>-->
<!--            </div>-->
            <h1>{{ $t('columns') }}</h1>
        </div>
        <div class="Columns-people">
            <div class="sub-container">
                <ul class="Columns-people-list" style="overflow-x: scroll">
                    <columns v-for="column in columns" :column="column" :class="{'active': column.id === activeColumn.id  }"></columns>
                </ul>
            </div>
        </div>
        <div class="sub-container">
            <a :href="'https://twitter.com/' + activeColumn.twitter_account"><span class="twitter-links">@{{activeColumn.twitter_account}}</span></a>
            <div class="Columns-intro">
<!--                <span>{{ $t('know_me_more') }} </span>-->
                <p>{{activeColumn.author_languages[0].pivot.bio}}</p>
            </div>
<!--            <div class="Columns-search">-->
<!--                <input type="text" placeholder="Search"/>-->
<!--            </div>-->
            <div class="row">

                    <selected-column-article v-for="article in articles.data" :article="article"></selected-column-article>


            </div>
            <div class="pagination-row">
                <a class="paginate-link" :href="articles.links[0].url">&#60;</a>
                <template v-for="(link, index) in articles.links">
                    <a class="paginate-link" :href="link.url"><p :class="{'active' : link.active}" v-if="index !== 0 && index !== articles.links.length - 1">
                        {{ link.label }}</p></a>
                </template>
                <a class="paginate-link" :href="articles.links[articles.links.length - 1].url">&#62;</a>
            </div>
        </div>
    </div>

</template>

<script>


import AnalysisMiddleFeatureArticle from "@/parts/categories/CategoryMiddleArticle.vue";
import AnalysisColumnsMiddleFeatureArticle from "@/parts/categories/CategoryColumnsMiddleArticle.vue";
import Columns from "@/parts/Columns/Columns.vue";
import SelectedColumnArticle from "@/parts/Columns/SelectedCoulmnArticle.vue";

export default {
    name: "ColumnsPage",
    computed: {},
    components: {SelectedColumnArticle, Columns, AnalysisColumnsMiddleFeatureArticle, AnalysisMiddleFeatureArticle},
    props: {
        columns: {
            type: Array,
            default: []
        },
        activeColumn: {
            type: Object,
        },
        articles: {
            type: Array,
            default: []
        }
    },
    data() {
        return {}
    },
    created() {
        //Reorder columns to have the active column first
        this.columns.sort((a, b) => {
            if (a.id === this.activeColumn.id) {
                return -1;
            }
            if (b.id === this.activeColumn.id) {
                return 1;
            }
            return 0;
        });
    }
}
</script>

<style scoped>

</style>
